import { render, staticRenderFns } from "./ScratchCardManual.vue?vue&type=template&id=1e45c1ec&scoped=true"
import script from "./ScratchCardManual.vue?vue&type=script&lang=js"
export * from "./ScratchCardManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e45c1ec",
  null
  
)

export default component.exports